import type { ReactNode } from 'react';
import { Anchor, AppShell, Button, Image, Stack, Text, Title } from '@mantine/core';
import { TwContainer } from '~/lib/TwContainer';
import { Link } from '@tanstack/react-router';
import clsx from 'clsx';
import { useMediaQuery } from '@mantine/hooks';

export const AppLayout = ({
	children,
	logo,
	isLionsTech,
}: Readonly<{
	children: ReactNode;
	logo: string;
	isLionsTech?: boolean;
}>) => {
	const isMobile = useMediaQuery('(max-width: 600px)');
	return (
		<AppShell
			layout={'default'}
			header={{ height: 84 }}
			withBorder={false}>
			<AppShell.Header className={clsx({ 'bg-dark': !isLionsTech, 'bg-white': isLionsTech })}>
				<TwContainer
					row
					className={'justify-between items-center h-full md:px-8 px-4'}>
					<Link to={'/'}>
						<Image
							src={logo}
							w={150}
						/>
					</Link>
					<Button.Group>
						<Button
							component={Link}
							to={'/about'}
							className="text-background"
							size={isMobile ? 'xs' : 'md'}
							variant="light">
							About Us
						</Button>

						<Button
							component={Link}
							size={isMobile ? 'xs' : 'md'}
							to={'/contact'}>
							Contact Us
						</Button>
					</Button.Group>
				</TwContainer>
			</AppShell.Header>
			<AppShell.Main style={{ minHeight: 'unset' }}>{children}</AppShell.Main>
			<footer
				className={clsx('relative pb-12', {
					'bg-dark': !isLionsTech,
					'bg-white': isLionsTech,
				})}>
				<TwContainer className="flex md:flex-row flex-col px-12 gap-8 md:justify-between justify-center items-center md:gap-12  py-16">
					<Image
						fit={'contain'}
						h={100}
						className={'w-fit'}
						src={logo}
						alt="Champtek"
					/>
					<Stack gap={4}>
						<Title
							order={4}
							className={'font-saira text-primary'}>
							Office
						</Title>
						<Text className={'text-primary font-saira mb-0'}>
							13790 Nw 4 St, ste 111,
							<br />
							Sunrise, FL 33325
						</Text>
						<Anchor
							className={''}
							href={'mailto:info@champteks.com'}>
							info@champteks.com
						</Anchor>
						<Anchor
							className={'text-primary'}
							href={'tel:+1 (954) 250-2008'}>
							+1 (954) 250-2008
						</Anchor>
					</Stack>
					<div className={'flex md:flex-col flex-row gap-4 text-primary'}>
						<Link to={'/'}>Home</Link>
						<Link to={'/about'}>About Us</Link>
						<Link to={'/contact'}>Contact Us</Link>
					</div>
				</TwContainer>
				<div className={'text-primary text-center font-saira'}>Copyright © {new Date().getFullYear()} champtek. All rights reserved.</div>
			</footer>
		</AppShell>
	);
};
